import { Suspense, lazy } from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/sections/Hero';
import { Spinner } from '../components/ui/Spinner';

// Lazy load non-critical sections
const Features = lazy(() => import('../components/sections/Features').then(m => ({ default: m.Features })));
const CTA = lazy(() => import('../components/sections/CTA').then(m => ({ default: m.CTA })));

export function Landing() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Header />
      
      <main>
        <Hero />
        
        <Suspense fallback={
          <div className="flex justify-center py-20">
            <Spinner size="lg" />
          </div>
        }>
          <Features />
        </Suspense>

        <Suspense fallback={
          <div className="flex justify-center py-20">
            <Spinner size="lg" />
          </div>
        }>
          <CTA />
        </Suspense>
      </main>
      
      <Footer />
    </div>
  );
}